import type { FaireProductEntity } from "../../entity_types/product";

export const p_bs2w6jvqt2: FaireProductEntity = {
  token: "p_bs2w6jvqt2",
  type: "product",
  name: "Root",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/12ec8d91c6440d8e4cc1361073a23778205bba8135b71d07892e156d75b15467.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/466d0445ff4d82f29eab3aa463f4aa15adc9510624c6bd63cdbec767c2892aff.jpeg",
    "https://cdn.faire.com/fastly/3d4fcbff356dfd7d9871057d473da6626848115477365715821be74d4e20e4ff.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:01.288Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
